import * as React from "react";
import { Grid, Button, ScrollArea, Table, Badge, Divider } from "@mantine/core";
import dayjs from "dayjs";

import { IReconsetState } from "../../types";
import { useReconsetLogs } from "src/hooks";

export default function Logs({
  entityId,
  id,
  reconsetState,
  cancel,
}: {
  entityId: string | null | undefined;
  id: string | null | undefined;
  reconsetState: IReconsetState;
  cancel: () => void;
}) {
  const { data: logs } = useReconsetLogs(entityId, id, "");

  return (
    <>
      <ScrollArea
        style={{ height: "75vh" }}
        offsetScrollbars
        scrollbarSize={16}
      >
        <Table
          verticalSpacing="sm"
          fs="xs"
          horizontalSpacing={"xs"}
          style={{ marginBottom: "20px" }}
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>Id</Table.Th>
              <Table.Th
                style={{
                  minWidth: `150px`,
                }}
              >
                Date
              </Table.Th>
              <Table.Th>Type</Table.Th>
              <Table.Th
                style={{
                  minWidth: `250px`,
                }}
              >
                Details
              </Table.Th>
              <Table.Th>Error</Table.Th>
            </Table.Tr>
          </Table.Thead>

          <Table.Tbody>
            {logs && logs?.length > 0 ? (
              <>
                {(logs || []).map((log) => {
                  return (
                    <Table.Tr key={log.id}>
                      <Table.Td>{log.id}</Table.Td>
                      <Table.Td>
                        {dayjs(log.logDate).format("YYYY-MM-DD HH:mm:ss")}
                      </Table.Td>
                      <Table.Td>
                        {log.type.toUpperCase() === "ERROR" ? (
                          <Badge radius="xs" color={"red"} variant="light">
                            {log.type}
                          </Badge>
                        ) : (
                          <Badge radius="xs" color={"teal"} variant="light">
                            {log.type}
                          </Badge>
                        )}
                      </Table.Td>
                      <Table.Td>{log.details}</Table.Td>
                      <Table.Td>{log.error}</Table.Td>
                    </Table.Tr>
                  );
                })}
              </>
            ) : (
              <>
                <Divider
                  label="No logs"
                  color="gray"
                  mt="lg"
                  labelPosition="left"
                />
              </>
            )}
          </Table.Tbody>
        </Table>
      </ScrollArea>

      <Grid align="stretch" gutter={"xs"}>
        <Grid.Col span={2}>
          <Button
            variant="default"
            fullWidth
            aria-label="Cancel"
            onClick={cancel}
          >
            Cancel
          </Button>
        </Grid.Col>
      </Grid>
    </>
  );
}
